
import { Vue, Component } from 'vue-property-decorator';
import { getDetail } from '../api';
@Component
export default class Detail extends Vue {
  detail: any = {};

  get query() {
    return this.$route.query;
  }
  created() {
    this.fetchDetail();
  }
  async fetchDetail() {
    const res = await getDetail(this.query.id as string);
    this.detail = res.data;
  }
  returnPage() {
    this.$router.go(-1);
  }
}
